[
  {
    "setKey": "set-vagabundo",
    "slot": "weapon",
    "name": "Espada del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "atkPct", "add": 5 }],
      [{ "stat": "atkPct", "add": 9 }],
      [{ "stat": "atkPct", "add": 14 }],
      [{ "stat": "atkPct", "add": 20 }],
      [{ "stat": "atkPct", "add": 28 }, { "stat": "critPct", "add": 5 }],
      [{ "stat": "atkPct", "add": 40 }, { "stat": "critPct", "add": 10 }]
    ]
  },
  {
    "setKey": "set-vagabundo",
    "slot": "ring",
    "name": "Anillo del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "critPct", "add": 3 }],
      [{ "stat": "critPct", "add": 5 }],
      [{ "stat": "critPct", "add": 8 }],
      [{ "stat": "critPct", "add": 11 }],
      [{ "stat": "critPct", "add": 15 }, { "stat": "lifestealPct", "add": 5 }],
      [{ "stat": "critPct", "add": 20 }, { "stat": "lifestealPct", "add": 10 }]
    ]
  },
  {
    "setKey": "set-vagabundo",
    "slot": "helm",
    "name": "Capucha del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "maxHpFlat", "add": 10 }],
      [{ "stat": "maxHpFlat", "add": 18 }],
      [{ "stat": "maxHpFlat", "add": 30 }],
      [{ "stat": "maxHpFlat", "add": 45 }],
      [{ "stat": "maxHpFlat", "add": 65 }, { "stat": "armor", "add": 2 }],
      [{ "stat": "maxHpFlat", "add": 90 }, { "stat": "armor", "add": 4 }]
    ]
  },
  {
    "setKey": "set-vagabundo",
    "slot": "chest",
    "name": "Túnica del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "armor", "add": 2 }],
      [{ "stat": "armor", "add": 3 }],
      [{ "stat": "armor", "add": 5 }],
      [{ "stat": "armor", "add": 7 }],
      [{ "stat": "armor", "add": 10 }, { "stat": "maxHpFlat", "add": 20 }],
      [{ "stat": "armor", "add": 14 }, { "stat": "maxHpFlat", "add": 35 }]
    ]
  },
  {
    "setKey": "set-vagabundo",
    "slot": "gloves",
    "name": "Guantes del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "doubleAtkPct", "add": 4 }],
      [{ "stat": "doubleAtkPct", "add": 7 }],
      [{ "stat": "doubleAtkPct", "add": 11 }],
      [{ "stat": "doubleAtkPct", "add": 15 }],
      [{ "stat": "doubleAtkPct", "add": 20 }, { "stat": "bonusProjectiles", "add": 1 }],
      [{ "stat": "doubleAtkPct", "add": 28 }, { "stat": "bonusProjectiles", "add": 2 }]
    ]
  },
  {
    "setKey": "set-vagabundo",
    "slot": "boots",
    "name": "Botas del Vagabundo",
    "rarityByTier": ["comun", "comun", "raro", "raro", "epico", "legendario"],
    "bonusByTier": [
      [{ "stat": "blockPct", "add": 4 }],
      [{ "stat": "blockPct", "add": 7 }],
      [{ "stat": "blockPct", "add": 11 }],
      [{ "stat": "blockPct", "add": 15 }],
      [{ "stat": "blockPct", "add": 20 }, { "stat": "enemyMissPct", "add": 5 }],
      [{ "stat": "blockPct", "add": 28 }, { "stat": "enemyMissPct", "add": 10 }]
    ]
  }
]
